// Self-service reset (design/auth-v4.html §6): POST /auth/password-resets
// {email}. The API answers 202 whoever the email belongs to and emails a
// one-hour reset link only to an account that exists — so this page says
// the same thing either way. The link lands on /set-password.

import { useState } from 'react';
import { Link } from 'react-router';
import { Logo } from '../components/Logo';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sentTo, setSentTo] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const resp = await fetch('/api/v1/auth/password-resets', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      if (resp.status !== 202) throw new Error('Could not send the email. Please try again.');
      setSentTo(email.trim());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not send the email.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main style={{ maxWidth: 380, margin: '0 auto', padding: '96px 24px' }}>
      <div style={{ color: 'var(--primary)', marginBottom: 28, transform: 'scale(1.6)', transformOrigin: 'left' }}>
        <Logo />
      </div>
      <h1 style={{ fontSize: 24, fontWeight: 800, letterSpacing: '-0.018em', marginBottom: 4 }}>Reset your password</h1>
      {sentTo ? (
        <div data-section="reset-sent">
          <p style={{ color: 'var(--ink-2)', fontSize: 14, margin: '8px 0 24px' }} role="status">
            If <b>{sentTo}</b> has a Restoplus account, a reset link is on its way. It works once, for an hour.
          </p>
          <Link to="/login" className="btn btn-outline" style={{ justifyContent: 'center' }}>Back to sign in</Link>
        </div>
      ) : (
        <>
          <p style={{ color: 'var(--ink-2)', fontSize: 14, marginBottom: 24 }}>We'll email you a link to choose a new one.</p>
          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input id="email" className="input" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            {error && <div className="err" role="alert">{error}</div>}
            <button className="btn btn-primary" disabled={busy} style={{ justifyContent: 'center' }}>
              {busy ? 'Sending…' : 'Email me a reset link'}
            </button>
          </form>
          <p style={{ fontSize: 13, marginTop: 20 }}>
            <Link to="/login" style={{ color: 'var(--primary)', fontWeight: 700 }}>Back to sign in</Link>
          </p>
        </>
      )}
    </main>
  );
}
